import React, { useEffect, useState } from "react";
import { getApi } from "../../../services/api/globalApi";
import Button from "../../../components/common/button/Button";
import * as XLSX from "xlsx";
import { errorMessage } from "../../../utils/toastify-message/ToastifyMessage";
import { usersCommisionsReportsColumns } from "../../../constant/tablesColumns/tablesColums";
import Table from "../../../components/common/table/Table";
import AllUserCommisionsReportsFilter from "./AllUserCommisionsReportsFilter";

function AllUserCommisionsReport() {
  const [data, setData] = useState([]);
  const [activeSearchButton, setActiveSearchButton] = useState(true);

  const getOrders = async (params) => {
    const path = "admin/reports/wallets/usersCommisions";
    try {
      setActiveSearchButton(false);
      const response = await getApi({
        path,
        params,
      });
      setActiveSearchButton(true);
      setData(response.data.result);
    } catch (error) {
      errorMessage(error.response?.data.errors[0]?.message);
    }
  };

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    getOrders(allFilter);
  };

  const handleExel = () => {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    XLSX.writeFile(workbook, "exported_data.xlsx");
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <div className="flex items-center justify-between">
        <h3 className="text-gray-800">لیست مجموع کمیسیون کاربران </h3>
        {data?.length ? (
          <Button
            color="success"
            type="button"
            onClick={handleExel}
            text={"خروجی اکسل"}
          />
        ) : null}
      </div>
      <div className="border-b border-gray-200 dark:border-gray-700">
        <AllUserCommisionsReportsFilter
          filterDataHandler={filterDataHandler}
          activeSearchButton={activeSearchButton}
        />
      </div>
      <div className="mt-4 w-full flex flex-col gap-4">
        <Table columns={usersCommisionsReportsColumns} rows={data} />
      </div>
    </div>
  );
}

export default AllUserCommisionsReport;
